document.addEventListener('DOMContentLoaded', function() {
  const checkboxes = document.querySelectorAll('.agreement-checkbox');
  const purchaseButton = document.querySelector('.product-form__submit');

  function updateButtonState() {
    const allChecked = Array.from(checkboxes).every(checkbox => checkbox.checked);
    purchaseButton.disabled = !allChecked;
  }

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', updateButtonState);
  });

  purchaseButton.disabled = true;  
  updateButtonState();  
});


// マイページのモーダル
document.addEventListener('DOMContentLoaded', function() {
  function setupModal(triggerId, modalId, closeClass) {
    const triggerModal = document.getElementById(triggerId);
    const modal = document.getElementById(modalId);
    const buttonClose = modal.getElementsByClassName(closeClass)[0];

    if (triggerModal) {
      triggerModal.addEventListener('click', function modalOpen() {
        if (modal) {
          modal.style.display = 'flex';
        }
      });
    }

    if (buttonClose) {
      buttonClose.addEventListener('click', function modalClose() {
        modal.style.display = 'none';
      });
    }

    addEventListener('click', function outsideClick(e) {
      if (e.target == modal) {
        modal.style.display = 'none';
      }
    });
  }

  setupModal('triggerModal', 'easyModal', 'modalClose');
  setupModal('triggerModal02', 'easyModal02', 'modalClose');
  setupModal('triggerModal03', 'easyModal03', 'modalClose');
});





// アコーディオン
document.querySelectorAll('.accordion-008').forEach(item => {
  item.querySelector('summary').addEventListener('click', () => {
      const panel = item.querySelector('.accordion-content');
      if (!item.open) {
          requestAnimationFrame(() => {
              // これはsummaryをクリックした直後に実行され、detailsが完全に開く前です。
              panel.style.maxHeight = panel.scrollHeight + "px";
          });
      } else {
          // 閉じる時はmaxHeightを0に設定
          panel.style.maxHeight = '0';
      }
  });
});
